(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5235,8566],{

/***/ 92536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomMetaHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CustomMetaHead(_ref) {
  var children = _ref.children,
      meta = _ref.meta;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [meta.title, " | ", "SUPERMARKET Κρητικός"]
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "keywords",
      content: meta.keywords
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "index, follow"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:title",
      content: "".concat(meta.title, " | ").concat("SUPERMARKET Κρητικός")
    }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:url",
      content: meta.url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image",
      content: meta.image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:width",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:height",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:alt",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:site_name",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "canonical",
      content: meta.url
    })]
  });
}

/***/ }),

/***/ 75747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferList; }
/* harmony export */ });
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76962);
/* harmony import */ var _OfferTile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51310);
/* harmony import */ var _ProductListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57730);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54820);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










function OfferList(_ref) {
  var offers = _ref.offers,
      _ref$waveSpecialProdu = _ref.waveSpecialProductsGrouped,
      waveSpecialProductsGrouped = _ref$waveSpecialProdu === void 0 ? [] : _ref$waveSpecialProdu,
      showBySelection = _ref.showBySelection;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      offersShown = _useState[0],
      setOffersShown = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    getFilteredProducts();
  }, [showBySelection, offers, router.query]);
  if (!offers.length && !waveSpecialProductsGrouped.length) return null;

  function getSortedOffers() {
    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].catalog */ .Z.catalog) {
      return offers;
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].expensive */ .Z.expensive) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'price', 'desc');
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].cheap */ .Z.cheap) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'price', 'asc');
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].alphabetical */ .Z.alphabetical) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'name', 'asc');
    }
  }

  function getFilteredProducts() {
    var offersByBannerOptions = getSortedOffers();
    setOffersShown(offersByBannerOptions);
  }

  return (offersShown && offersShown.length !== 0 || waveSpecialProductsGrouped && waveSpecialProductsGrouped.length !== 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listHeader),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
        className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listTitle),
        children: "\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BC\u03C6\u03AD\u03C1\u03B5\u03B9"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().bannerContainer),
      children: [waveSpecialProductsGrouped.length !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: waveSpecialProductsGrouped.map(function (p, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ProductListItem__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            _product: p,
            itemListId: "Offers",
            itemListName: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2",
            positionInList: index + 1
          }, p._id);
        })
      }), offersShown.map(function (o) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_OfferTile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          offer: o
        }, o._id);
      })]
    })]
  });
}

/***/ }),

/***/ 51310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferTile; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88362);
/* harmony import */ var _store_orderLimitations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39519);
/* harmony import */ var _utils_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1003);
/* harmony import */ var _RoundButton_ButtonCart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75547);
/* harmony import */ var _OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92477);
/* harmony import */ var _OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22838);
/* harmony import */ var _ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













var DISABLED_OFFER_WARNING = 'Το συγκεκριμένο προϊόν δεν είναι πλέον διαθέσιμο';
function OfferTile(_ref) {
  var _cn;

  var offer = _ref.offer,
      isHomeOffer = _ref.isHomeOffer,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var priceString = "\u20AC ".concat((offer.price / 100).toFixed(2), " ");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      displayInfoWindow = _useState[0],
      setDisplayInfoWindow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      productLimit = _useState2[0],
      setProductLimit = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      productQuantity = _useState3[0],
      setProductQuantity = _useState3[1];

  function offerUOM(_offer) {
    if (_offer.products.length !== 0 || _offer.groups.length !== 0) {
      return 'το σετ';
    }

    return 'το τεμάχιο';
  }

  function productsLimitReachedWrapper(limit) {
    var quantity = _store_cart__WEBPACK_IMPORTED_MODULE_4__/* .productsQuantities.getValue */ .UU.getValue();
    (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .productsLimitReached */ .B2)(offer, quantity[offer._id], setDisplayInfoWindow, limit);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var productsQuantities$ = _store_cart__WEBPACK_IMPORTED_MODULE_4__/* .productsQuantities.subscribe */ .UU.subscribe(function (productQuantities) {
      var _productQuantity = productQuantities[offer._id];
      setProductQuantity(_productQuantity);
    });
    var orderLimitations$ = _store_orderLimitations__WEBPACK_IMPORTED_MODULE_5__/* ["default"].subscribe */ .Z.subscribe(function (orderLimitations) {
      var limit = (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .getProductOrderLimit */ .sA)(orderLimitations, offer);
      setProductLimit(limit);
    });
    return function () {
      orderLimitations$.unsubscribe();
      productsQuantities$.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (!productLimit) return;
    productsLimitReachedWrapper(productLimit);
  }, [productQuantity, productLimit]);
  var imgSrc = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(offer, 'image.webSmallThumb', '');
  var searchResultsImage = offer.image.baseUrl + offer.image.primary;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productItem), (_cn = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_cn, (_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default().offerProductItem), isHomeOffer), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_cn, (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().disabledProduct), disabled), _cn)),
    title: disabled ? DISABLED_OFFER_WARNING : undefined,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      href: (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .offerLink */ .m9)(offer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
        className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productLink),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().layoutSmall),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("header", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().badgeOffer),
              children: offer.webSticker
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("img", {
              loading: "lazy",
              src: imgSrc || searchResultsImage,
              width: "200",
              height: "200",
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productImage),
              alt: offer.name
            }), displayInfoWindow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().infoWindow),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                children: "\u0388\u03C7\u03B5\u03B9\u03C2 \u03C6\u03C4\u03AC\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u03C0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2"
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("main", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().main),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
              children: offer.name
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().titleDesc),
              title: offer.description,
              children: offer.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description),
              children: [priceString, offerUOM(offer)]
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btnContainer), (_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnContainer)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().priceFooter),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().finalPriceContainer),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().finalPrice),
            children: priceString
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_RoundButton_ButtonCart__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        product: offer,
        productLimit: productLimit,
        quantity: productQuantity,
        isEditable: true,
        removed: disabled
      })]
    })]
  });
}

/***/ }),

/***/ 98924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GQ": function() { return /* binding */ SMART; },
/* harmony export */   "JD": function() { return /* binding */ USER_PROFILE; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "jn": function() { return /* binding */ OFFERS; },
/* harmony export */   "ve": function() { return /* binding */ HOMEPAGE; }
/* harmony export */ });
/* unused harmony export ORDER_HISTORY */
var HOMEPAGE = '/';
var USER_PROFILE = '/user';
var ORDER_HISTORY = '/useσr/history';
var OFFERS = '/offers';
var CATEGORIES = '/categories';
var SMART = '/smart';

/***/ }),

/***/ 56511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ LandingPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js + 3 modules
var combineLatest = __webpack_require__(60236);
// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomMetaHead.jsx
var CustomMetaHead = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/store/products.js
var store_products = __webpack_require__(58345);
// EXTERNAL MODULE: ./src/components/LandingPageLayout.module.scss
var LandingPageLayout_module = __webpack_require__(17736);
var LandingPageLayout_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageLayout_module);
// EXTERNAL MODULE: ./src/components/ProductsMenu/OfferList.jsx
var OfferList = __webpack_require__(75747);
// EXTERNAL MODULE: ./src/components/ProductsMenu/OfferTile.jsx
var OfferTile = __webpack_require__(51310);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductListItem.jsx + 1 modules
var ProductListItem = __webpack_require__(57730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/LandingPageLayout.jsx













function LandingPageLayout(_ref) {
  var _cmsData$fields, _cmsData$fields$secti, _section$image;

  var _ref$showProductCateg = _ref.showProductCategories,
      showProductCategories = _ref$showProductCateg === void 0 ? false : _ref$showProductCateg,
      _ref$cmsData = _ref.cmsData,
      cmsData = _ref$cmsData === void 0 ? {} : _ref$cmsData,
      _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      _ref$categoriesShowin = _ref.categoriesShowing,
      categoriesShowing = _ref$categoriesShowin === void 0 ? [] : _ref$categoriesShowin,
      _ref$offersShowing = _ref.offersShowing,
      offersShowing = _ref$offersShowing === void 0 ? [] : _ref$offersShowing;
  var section = cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$fields = cmsData.fields) === null || _cmsData$fields === void 0 ? void 0 : (_cmsData$fields$secti = _cmsData$fields.sections) === null || _cmsData$fields$secti === void 0 ? void 0 : _cmsData$fields$secti[0];
  var heading = (section === null || section === void 0 ? void 0 : section.heading) || '';
  var imgSrc = section === null || section === void 0 ? void 0 : (_section$image = section.image) === null || _section$image === void 0 ? void 0 : _section$image.path;
  var imgTitle = (cmsData === null || cmsData === void 0 ? void 0 : cmsData.title) || '';
  var text = (section === null || section === void 0 ? void 0 : section.text) || '';
  var showBySelection = 'default';

  var _useState = (0,react.useState)(false),
      isCartVisible = _useState[0],
      setIsCartVisible = _useState[1];

  (0,react.useEffect)(function () {
    var isCartVisible$ = cart/* default.getIsVisble$ */.ZP.getIsVisble$().subscribe(setIsCartVisible);

    if (store_products/* ActiveProduct.getValue */.nv.getValue() !== '') {
      loader/* default.addEvent */.Z.addEvent('FEATURED_SCROLL');
      scrollToActiveProduct();
    }

    return function () {
      isCartVisible$.unsubscribe();
    };
  }, []);

  function scrollToActiveProduct() {
    setTimeout(function () {
      var elemToScrollTo = document.getElementById("pr".concat(store_products/* ActiveProduct.getValue */.nv.getValue()));

      if (elemToScrollTo) {
        elemToScrollTo.scrollIntoView({
          behavior: 'auto',
          block: 'center'
        });
        store_products/* ActiveProduct.update */.nv.update('');
        loader/* default.removeEvent */.Z.removeEvent('FEATURED_SCROLL');
      } else {
        store_products/* ActiveProduct.update */.nv.update('');
      }
    }, 500);
  }

  if (!products) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (LandingPageLayout_module_default()).content,
    children: [imgSrc && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (LandingPageLayout_module_default()).imageContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (LandingPageLayout_module_default()).img,
        src: imgSrc,
        alt: imgTitle
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (LandingPageLayout_module_default()).listHeader,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: (LandingPageLayout_module_default()).listTitle,
        children: heading
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (LandingPageLayout_module_default()).listText,
      dangerouslySetInnerHTML: {
        __html: text
      }
    }), !showProductCategories ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()((LandingPageLayout_module_default()).productList, (0,defineProperty/* default */.Z)({}, (LandingPageLayout_module_default()).spaceOpenCart, isCartVisible)),
      children: [!isEmpty_default()(offersShowing) && offersShowing.map(function (offer) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferTile/* default */.Z, {
          offer: offer
        }, offer.friendlyId);
      }), !isEmpty_default()(products) && products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListItem/* default */.Z, {
          _product: product
        }, product._id);
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (LandingPageLayout_module_default()).defaultContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (LandingPageLayout_module_default()).listSearch,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferList/* default */.Z, {
          offers: offersShowing,
          showBySelection: showBySelection
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: classnames_default()((LandingPageLayout_module_default()).listSearch),
        children: categoriesShowing.map(function (c, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (LandingPageLayout_module_default()).listHeader,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (LandingPageLayout_module_default()).listTitle,
                children: c.name
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (LandingPageLayout_module_default()).listContainer,
              "data-cy": "search-list",
              children: products[index] && products[index].map(function (p) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListItem/* default */.Z, {
                  _product: p
                }, p._id);
              })
            })]
          }, c._id);
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/LandingPageRecipes.module.scss
var LandingPageRecipes_module = __webpack_require__(46934);
var LandingPageRecipes_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageRecipes_module);
// EXTERNAL MODULE: ./src/components/RedirectImage/RedirectImage.module.scss
var RedirectImage_module = __webpack_require__(16742);
var RedirectImage_module_default = /*#__PURE__*/__webpack_require__.n(RedirectImage_module);
;// CONCATENATED MODULE: ./src/components/RedirectImage/RedirectImage.jsx




function RedirectImage(_ref) {
  var _tile$fields, _tile$fields2, _tile$fields2$image;

  var tile = _ref.tile,
      altText = _ref.altText;
  var tileTitle = tile === null || tile === void 0 ? void 0 : tile.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (RedirectImage_module_default()).bannerContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (RedirectImage_module_default()).bannerTitle,
      children: tileTitle || altText
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: (tile === null || tile === void 0 ? void 0 : (_tile$fields = tile.fields) === null || _tile$fields === void 0 ? void 0 : _tile$fields.redirectionLink) || '/#',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        "aria-label": tileTitle || altText,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (RedirectImage_module_default()).img,
          src: tile === null || tile === void 0 ? void 0 : (_tile$fields2 = tile.fields) === null || _tile$fields2 === void 0 ? void 0 : (_tile$fields2$image = _tile$fields2.image) === null || _tile$fields2$image === void 0 ? void 0 : _tile$fields2$image.path,
          width: 320,
          height: 220,
          alt: tileTitle || altText
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/LandingPageRecipes.jsx




function LandingPageRecipes(_ref) {
  var _cmsData$fields, _cmsData$fields$secti;

  var _ref$cmsData = _ref.cmsData,
      cmsData = _ref$cmsData === void 0 ? {} : _ref$cmsData,
      _ref$redirections = _ref.redirections,
      redirections = _ref$redirections === void 0 ? {} : _ref$redirections;
  var section = cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$fields = cmsData.fields) === null || _cmsData$fields === void 0 ? void 0 : (_cmsData$fields$secti = _cmsData$fields.sections) === null || _cmsData$fields$secti === void 0 ? void 0 : _cmsData$fields$secti[0];
  var recipesHeader = (section === null || section === void 0 ? void 0 : section.recipes_header) || '';
  var redirectionsIds = (section === null || section === void 0 ? void 0 : section.redirectionLink) || [];
  var redirectionsRecipes = redirections.filter(function (redirection) {
    return redirectionsIds.includes(redirection.uuid);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (LandingPageRecipes_module_default()).container,
    children: [recipesHeader && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (LandingPageRecipes_module_default()).listHeader,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (LandingPageRecipes_module_default()).listTitle,
        children: recipesHeader
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (LandingPageRecipes_module_default()).listContainer,
      children: redirectionsRecipes === null || redirectionsRecipes === void 0 ? void 0 : redirectionsRecipes.map(function (tile) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(RedirectImage, {
          tile: tile,
          altText: "\u03C3\u03C5\u03BD\u03C4\u03B1\u03B3\u03AE"
        }, tile === null || tile === void 0 ? void 0 : tile.uuid);
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
// EXTERNAL MODULE: ./src/store/categories.js
var categories = __webpack_require__(9266);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/productsCollection.js
var productsCollection = __webpack_require__(67713);
// EXTERNAL MODULE: ./src/utils/getBreadcrumb.js
var getBreadcrumb = __webpack_require__(65269);
// EXTERNAL MODULE: ./src/utils/products.js
var products = __webpack_require__(1003);
;// CONCATENATED MODULE: ./src/pages/featured/[slug].jsx





















var __N_SSG = true;
function LandingPage(_ref) {
  var cmsData = _ref.cmsData,
      slug = _ref.slug,
      redirections = _ref.redirections,
      offers = _ref.offers,
      featuredSKUs = _ref.featuredSKUs,
      featuredOffers = _ref.featuredOffers,
      footerLinks = _ref.footerLinks,
      navigation = _ref.navigation,
      meta = _ref.meta;

  var _useState = (0,react.useState)(),
      productsShowing = _useState[0],
      setProductsShowing = _useState[1];

  var _useState2 = (0,react.useState)(),
      categoriesShowing = _useState2[0],
      setCategoriesShowing = _useState2[1];

  var _useState3 = (0,react.useState)(),
      offersShowing = _useState3[0],
      setOffersShowing = _useState3[1];

  var isDivideToCategories = cmsData.fields.sections[0].divideCategories;
  var breadcrumbData = (0,getBreadcrumb/* getBreadcrumbTwoStep */.xk)(slug);
  var breadcrumb = (0,getBreadcrumb/* createBreadcrumbJson */.El)(breadcrumbData);
  (0,react.useEffect)(function () {
    var categoriesAndProducts$ = (0,combineLatest/* combineLatest */.aj)([categories/* default.subject */.Z.subject, productsCollection/* default.subject */.Z.subject]).subscribe(function (categoriesAndProducts) {
      var _featuredSKUs$map;

      var _categoriesAndProduct = (0,slicedToArray/* default */.Z)(categoriesAndProducts, 2),
          _categories = _categoriesAndProduct[0],
          _productCollections = _categoriesAndProduct[1];

      if (!_categories.length || !_productCollections) return;
      var service = deliveryMode/* default.getValue */.Z.getValue();
      var collectionType = deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(service);

      var _allProductsIncollections = productsCollection/* default.getProductsForCollections */.Z.getProductsForCollections(collectionType);

      if (!(_allProductsIncollections !== null && _allProductsIncollections !== void 0 && _allProductsIncollections.length)) return;

      var _productsShowing = featuredSKUs // eslint-disable-next-line max-len
      === null || featuredSKUs // eslint-disable-next-line max-len
      === void 0 ? void 0 : (_featuredSKUs$map = featuredSKUs // eslint-disable-next-line max-len
      .map(function (sku) {
        return _allProductsIncollections.find(function (product) {
          return product.sku === sku && product.enabled && product.available;
        });
      })) === null || _featuredSKUs$map === void 0 ? void 0 : _featuredSKUs$map.filter(function (p) {
        return p;
      });

      if (!isDivideToCategories) {
        setProductsShowing(_productsShowing);
        return;
      }

      var _splitProductsIntoCat = (0,products/* splitProductsIntoCategories */.T0)(_productsShowing, _categories),
          _splitProductsIntoCat2 = (0,slicedToArray/* default */.Z)(_splitProductsIntoCat, 2),
          productsOrderSorted = _splitProductsIntoCat2[0],
          categoriesArrayFiltered = _splitProductsIntoCat2[1];

      setCategoriesShowing(categoriesArrayFiltered);
      setProductsShowing(productsOrderSorted);
    });
    var deliveryMode$ = deliveryMode/* default.subscribe */.Z.subscribe(function (service) {
      var _featuredOffers$map;

      var collectionType = deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(service);
      var mainCollectionType = collectionType.find(function (c) {
        return c === "900" || c === '751';
      });
      var mainCollectionTypeNumber = parseInt(mainCollectionType);

      var _offersShowing = featuredOffers === null || featuredOffers === void 0 ? void 0 : (_featuredOffers$map = featuredOffers.map(function (friendlyId) {
        return offers.find(function (offer) {
          return offer.friendlyId === friendlyId;
        });
      })) === null || _featuredOffers$map === void 0 ? void 0 : _featuredOffers$map.filter(function (o) {
        return o === null || o === void 0 ? void 0 : o.collectionTypes.includes(mainCollectionTypeNumber);
      });

      setOffersShowing(_offersShowing);
    });
    return function () {
      deliveryMode$.unsubscribe();
      categoriesAndProducts$.unsubscribe();
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(breadcrumb)
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomMetaHead/* default */.Z, {
      meta: meta
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingPageLayout, {
      cmsData: cmsData,
      products: productsShowing,
      showProductCategories: isDivideToCategories,
      categoriesShowing: categoriesShowing,
      offersShowing: offersShowing
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingPageRecipes, {
      cmsData: cmsData,
      redirections: redirections
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (LandingPageLayout_module_default()).linkContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: routes/* OFFERS */.jn,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (LandingPageLayout_module_default()).link,
          children: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 58345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eH": function() { return /* binding */ CalledProductCategories; },
/* harmony export */   "nv": function() { return /* binding */ ActiveProduct; },
/* harmony export */   "r1": function() { return /* binding */ CalledSuperProductCategories; },
/* harmony export */   "vX": function() { return /* binding */ RenderedProducts; }
/* harmony export */ });
/* unused harmony export ProductsStore */
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20090);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70051);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55709);
/* harmony import */ var _api_Products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16562);





var FETCH_STATUSES = {
  UNFETCHED: 'UNFETCHED',
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
};
var subjectProducts = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X([]);
var statusSub = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(FETCH_STATUSES.UNFETCHED);
var activeProduct = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X('');
var renderedProduct = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X({});
var calledProductCategories = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(1);
var calledSuperProductCategories = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(1);
var ActiveProduct = {
  update: function update(id) {
    activeProduct.next(id);
  },
  subscribe: function subscribe(setState) {
    return activeProduct.subscribe(setState);
  },
  getValue: function getValue() {
    return activeProduct.value;
  }
};
var CalledProductCategories = {
  update: function update(id) {
    calledProductCategories.next(id);
  },
  subscribe: function subscribe(setState) {
    return calledProductCategories.subscribe(setState);
  },
  getValue: function getValue() {
    return calledProductCategories.value;
  }
};
var CalledSuperProductCategories = {
  update: function update(id) {
    calledSuperProductCategories.next(id);
  },
  subscribe: function subscribe(setState) {
    return calledSuperProductCategories.subscribe(setState);
  },
  getValue: function getValue() {
    return calledSuperProductCategories.value;
  }
};
var RenderedProducts = {
  update: function update(products) {
    renderedProduct.next(products);
  },
  subscribe: function subscribe(setState) {
    return renderedProduct.subscribe(setState);
  },
  getValue: function getValue() {
    return renderedProduct.value;
  }
};
var ProductsStore = {
  update: function update(products) {
    statusSub.next(FETCH_STATUSES.FETCHED);
    subjectProducts.next(products);
    return products;
  },
  subscribe: function subscribe(setState) {
    return subjectProducts.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectProducts.value;
  },

  /**
   * If fetching, return when response is ready
   * If fetched, return data from the memory
   * If fetched or (fetched & force update)
   * requests data from server
   * @param {Boolean} forceUpdate
   * @returns products
   */
  getOrFetch: function getOrFetch() {
    var _arguments = arguments;
    return (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var forceUpdate, products;
      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              forceUpdate = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

              if (!(statusSub.getValue() === FETCH_STATUSES.FETCHING)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", statusSub.pipe((0,rxjs_operators__WEBPACK_IMPORTED_MODULE_4__/* .skipUntil */ .u)(function (v) {
                return v === FETCH_STATUSES.FETCHED;
              }), (0,rxjs_operators__WEBPACK_IMPORTED_MODULE_5__/* .map */ .U)(function () {
                return subjectProducts.getValue();
              })).toPromise());

            case 3:
              if (!(!forceUpdate && statusSub.getValue() === FETCH_STATUSES.FETCHED)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", ProductsStore.getValue());

            case 5:
              statusSub.next(FETCH_STATUSES.FETCHING);
              _context.next = 8;
              return (0,_api_Products__WEBPACK_IMPORTED_MODULE_1__/* .getProductsWithDetails */ .Hf)();

            case 8:
              products = _context.sent;
              return _context.abrupt("return", ProductsStore.update(products.products));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  ProductsStore: ProductsStore
});

/***/ }),

/***/ 65269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ getBreadcrumbValidation; },
/* harmony export */   "El": function() { return /* binding */ createBreadcrumbJson; },
/* harmony export */   "aY": function() { return /* binding */ getBreadcrumbStepProduct; },
/* harmony export */   "xk": function() { return /* binding */ getBreadcrumbTwoStep; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

function createBreadcrumbJson(list) {
  var breadcrumb = list.map(function (value, index) {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: value.name,
      item: value.url
    };
  });
  var json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumb
  };
  return json;
}
function getBreadcrumbStepProduct(slug, index) {
  var step = slug.slice(0, index + 1).join('/');

  if (index === slug.length - 1) {
    return {
      url: "".concat("https://kritikos-sm.gr", "/products/").concat(step, "/"),
      name: slug[index].split('-')[0]
    };
  }

  return {
    url: "".concat("https://kritikos-sm.gr", "/categories/").concat(step, "/"),
    name: slug[index]
  };
}
function getBreadcrumbValidation(data) {
  if (data.length === 4) {
    return [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(0, 2)), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(3)));
  }

  return data;
}
function getBreadcrumbTwoStep(link) {
  var firstStep = link.split('/')[0];
  return [{
    url: "".concat("https://kritikos-sm.gr", "/").concat(firstStep, "/"),
    name: firstStep
  }, {
    url: "".concat("https://kritikos-sm.gr", "/").concat(link, "/"),
    name: link.split('/')[1]
  }];
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  createBreadcrumbJson: createBreadcrumbJson,
  getBreadcrumbStepProduct: getBreadcrumbStepProduct,
  getBreadcrumbTwoStep: getBreadcrumbTwoStep,
  getBreadcrumbValidation: getBreadcrumbValidation
});

/***/ }),

/***/ 3777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured/[slug]",
      function () {
        return __webpack_require__(56511);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17736:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"LandingPageLayout_content__o7qZ7","imageContainer":"LandingPageLayout_imageContainer__4eOCr","img":"LandingPageLayout_img__6Bkv0","listSearch":"LandingPageLayout_listSearch__INxF3","listTitle":"LandingPageLayout_listTitle__FiDTr","listHeader":"LandingPageLayout_listHeader__Jy74f","listText":"LandingPageLayout_listText__zMY8T","productList":"LandingPageLayout_productList__Pdnps","linkContainer":"LandingPageLayout_linkContainer__zosQa","link":"LandingPageLayout_link__wxecH","spaceOpenCart":"LandingPageLayout_spaceOpenCart__Kufbm","listContainer":"LandingPageLayout_listContainer__fKuoQ"};

/***/ }),

/***/ 46934:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageRecipes_container__EDlAs","listTitle":"LandingPageRecipes_listTitle__auFGa","listHeader":"LandingPageRecipes_listHeader__R_LDh","listContainer":"LandingPageRecipes_listContainer__PofSv"};

/***/ }),

/***/ 92477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerProductItem":"OfferTile_offerProductItem__OLcDJ","btnContainer":"OfferTile_btnContainer__uEgA_"};

/***/ }),

/***/ 54820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"ProductMenu_listContainer__ks2Ns","infiniteList":"ProductMenu_infiniteList__8zE3B","notSticky":"ProductMenu_notSticky__Q5FIP","listTitle":"ProductMenu_listTitle__PxrUW","listHeader":"ProductMenu_listHeader__Crgmj","options":"ProductMenu_options__soiZ6","bannerContainer":"ProductMenu_bannerContainer__V5Oou","categoryContainer":"ProductMenu_categoryContainer__TQ0Xh","selectBrand":"ProductMenu_selectBrand__blXFc","centerNoProducts":"ProductMenu_centerNoProducts__LB64y","bannerLink":"ProductMenu_bannerLink__jJoSR","hideOnSmallScreen":"ProductMenu_hideOnSmallScreen__L_Gdk","visibilityHidden":"ProductMenu_visibilityHidden__6Pghu"};

/***/ }),

/***/ 16742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"RedirectImage_bannerContainer__KUDpy","bannerTitle":"RedirectImage_bannerTitle__V6leK","img":"RedirectImage_img__ARaep"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; },
/* harmony export */   "df": function() { return /* binding */ InView; }
/* harmony export */ });
/* unused harmony exports default, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 70051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ skipUntil; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17604);
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__/* .SimpleInnerSubscriber */ .IY(_this);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = (0,_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__/* .innerSubscribe */ .ft)(notifier, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function () {
        this.hasValue = true;
        if (this.innerSubscription) {
            this.innerSubscription.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
    };
    return SkipUntilSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__/* .SimpleOuterSubscriber */ .Ds));
//# sourceMappingURL=skipUntil.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,9950,7730,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(3777); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);